import {DataTable, DataTableProps} from '@hconnect/uikit/src/lib2'
import {Theme, SxProps} from '@mui/material'
import {useMemo} from 'react'

interface PlannerDataTableProps<T> extends Omit<DataTableProps<T>, 'rowSx'> {
  rowSx?: (row: T) => SxProps<Theme>
  isRowSelected?: (row: T) => boolean
  isRowClickable?: (row: T) => boolean
}

export const PlannerDataTable = <T,>({
  rowSx,
  isRowSelected,
  isRowClickable,
  ...dataTableProps
}: PlannerDataTableProps<T>) => {
  const defaultRowSx: SxProps<Theme> = useMemo(
    () => ({
      '&:hover': {
        backgroundColor: ({palette}) => palette.action.hover
      }
    }),
    []
  )

  const resolvedRowSx = (row: T): SxProps<Theme> => ({
    ...defaultRowSx,
    cursor: isRowClickable?.(row) ? 'pointer' : 'default',
    backgroundColor: isRowSelected?.(row)
      ? ({palette}: Theme) => palette.action.selected
      : undefined,
    ...(rowSx?.(row) as object)
  })

  return <DataTable rowSx={resolvedRowSx} {...dataTableProps} />
}
